import { HOME_DESCRIPTION } from "@/lib/seo";

// Static description of what FSR Studio prepares. Not dismissible.
export const STUDIO_DESCRIPTION = HOME_DESCRIPTION;

export default function StudioDescription({
    className = "",
    testId = "studio-description",
}) {
    return (
        <div
            className={`border border-[var(--fsrs-sky)] bg-[color-mix(in_srgb,var(--fsrs-muted)_8%,transparent)] px-5 py-4 sm:px-6 sm:py-5 ${className}`}
            data-testid={testId}
            role="note"
        >
            <p className="text-[var(--fsrs-muted)] text-base sm:text-lg leading-relaxed">
                {STUDIO_DESCRIPTION}
            </p>
        </div>
    );
}
